<template>
    <CardBase title="Últimos boletines enviados" :loading="loading">
        <table v-if="ultimosBoletines.length > 0" class="table table-striped w-100">
            <tbody>
                <tr v-for="item in ultimosBoletines" :key="item.id">
                    <td>
                        <router-link
                            :to="{
                                name: 'back.emails.boletines.show',
                                params: { id: item.id },
                            }"
                            class="asunto-boletin-url"
                        >
                            {{ item.asunto }}
                        </router-link>
                    </td>
                    <td class="text-center">
                        <div
                            :class="[
                                'alert text-center',
                                item.estado === 'Enviado'
                                    ? 'alert-success'
                                    : 'alert-secondary',
                                'p-1 mb-0',
                            ]"
                            style="width: 110px; margin-left: auto; margin-right: auto"
                        >
                            <template v-if="item.estado === 'Enviado'">
                                <i class="fas fa-check-circle mr-1"></i>
                                Enviado
                            </template>
                            <template v-else>
                                <i class="fas fa-times-circle mr-1"></i>
                                Enviando...
                            </template>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-else class="alert text-center">No hay boletines disponibles</div>
    </CardBase>
</template>

<script>
    import CardBase from "./common/CardBase";
    import apiService from "@/services/api-comunicados";

    export default {
        name: 'UltimosBoletines',
        data() {
            return {
                loading: false,
                ultimosBoletines: []
            };
        },
        created() {
            this.getUltimosComunicados();
        },
        methods: {
            async getUltimosComunicados() {
                this.loading = true;

                try {
                    const response = await apiService.getUltimosBoletines();
                    this.ultimosBoletines = response.data;
                } catch (error) {
                    console.error("Error al obtener los últimos boletines:", error);
                    this.$toast.error("Error al cargar los boletines. Por favor, inténtelo más tarde.");
                } finally {
                    this.loading = false;
                }
            },
        },
        components: {
            CardBase
        }
    };
</script>

<style scoped>
    .asunto-boletin-url:hover {
        text-decoration: underline;
        cursor: pointer;
    }
</style>
